export const SZ_COMPANY_ID = 1;
